import { initializeApp } from 'firebase/app';

import config from '...config/firebase/private/config.js';

export const app = initializeApp(config);
